<div class="actions-container mr-2">
<div class="flex-col gap-1">
<button mat-raised-button class="new-button" (click)="addNewApplicant()">New Applicant </button>
<button mat-raised-button class="import-button" (click)="importApplicant()">Import Applicants </button>
<button mat-raised-button class="new-import-link-button" (click)="newApplicantImportLink()">Create Public Applying Link </button>
</div>
</div>

